/**
 * Utility functions for dummy client functionality
 */

/**
 * Get the list of dummy client IDs from environment variables
 * @returns Array of dummy client IDs
 */
export const getDummyClientIds = (): number[] => {
  try {
    return window.envVariables.REACT_DUMMY_PAGES_CLIENT_IDS
      ? JSON.parse(window.envVariables.REACT_DUMMY_PAGES_CLIENT_IDS)
      : []
  } catch (error) {
    console.warn('Failed to parse REACT_DUMMY_PAGES_CLIENT_IDS:', error)
    return []
  }
}

/**
 * Check if dummy mode is disabled by user preference
 * @returns True if dummy mode is disabled via localStorage
 */
export const isDummyModeDisabled = (): boolean => {
  try {
    const disabled = localStorage.getItem('dummy_mode_disabled')
    return disabled === 'true'
  } catch (error) {
    console.warn('Failed to read dummy_mode_disabled from localStorage:', error)
    return false
  }
}

/**
 * Toggle dummy mode on/off
 * @param disabled - Whether to disable dummy mode
 */
export const setDummyModeDisabled = (disabled: boolean): void => {
  try {
    localStorage.setItem('dummy_mode_disabled', disabled.toString())
  } catch (error) {
    console.warn('Failed to set dummy_mode_disabled in localStorage:', error)
  }
}

/**
 * Check if a client ID is a dummy client
 * @param clientId - The client ID to check
 * @returns True if the client is a dummy client, false otherwise
 */
export const isDummyClient = (clientId: number | null | undefined): boolean => {
  if (!clientId) return false

  // If dummy mode is disabled by user, return false
  if (isDummyModeDisabled()) return false

  const dummyClientIds = getDummyClientIds()

  return dummyClientIds.includes(clientId)
}

export const isBaehTransferClient = (clientId: number | null | undefined): boolean => {
  return clientId === 248
}
